<template>
  <ModalDialog
    ref="dialog"
    title="Move Panel"
    icon="fa-random"
    :showFooter="true"
    :submitting="submitting"
    submitTitle="Move"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />

    <div v-if="!loading && productionPanelData">
      <FormGroup v-bind:form="form" :labelColumnSize="3">
        <FormRow label="Inventory Bin">
          <FormInventoryBinSelect
            v-model="productionPanelData.inventoryBinId"
            placeholder="Inventory Bin"
            field="inventoryBinId"
          />
        </FormRow>
      </FormGroup>
    </div>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import FormInventoryBinSelect from '@/modules/inventory/components/formInventoryBinSelect'

export default {
  name: 'MovePanelDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    FormInventoryBinSelect
  },
  props: {
    productionStationId: Number,
    productionPanelId: Number
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      productionPanelData: null,
      productionStation: {},
      form: {},
      submitting: false
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
  
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      this.requestPanelData()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      // Send revert request
      this.form = this.clearFormResponse()

      var moveData = {
        inventoryBinId: this.productionPanelData.inventoryBinId
      }

      this.submitting = true
      this.$apiService.glassProductionStationService.movePanel(this.productionPanelId, moveData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },

    requestPanelData() {
      this.loading = true
      this.loadingError = ''

      Promise.all([
        this.$apiService.glassProductionStationService.getProductionPanel(this.productionPanelId),
        this.$apiService.productionService.getProductionStation(this.productionStationId)
      ])
      .then(results => {
        this.productionPanelData = results[0].data
        this.productionStation = results[1].data
      })
      .catch(err => {
        this.loadingError = 'Error loading panel data'
      })
      .finally(() => {
        this.loading = false
      })
    },
  }
}
</script>